/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-03-17 18:33:20
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-03-17 21:01:56
 * @FilePath: /intl-pc-jdi-website-ssr/src/components/product/const.ts
 * @Description: default
 */
import AssuranceIcon1 from '@/images/icon/assurance-icons-1.png';
import AssuranceIcon2 from '@/images/icon/assurance-icons-2.png';
import AssuranceIcon3 from '@/images/icon/assurance-icons-3.png';

import AssuranceIconDefault from '@/images/icon/assurance-icons-3-4.png';
import BankCard1 from '@/images/icon/bank-card-1.png';
import BankCard2 from '@/images/icon/bank-card-2.png';
import BankCard3 from '@/images/icon/bank-card-3.png';
import BankCard4 from '@/images/icon/bank-card-4.png';
import { cnHelper } from '@/utils';

// 每个路由指定className scope
export const CN_PRODUCT = cnHelper('product');

export const getAssureIcon = (index: number) =>
  [AssuranceIcon1, AssuranceIcon2, AssuranceIcon3]?.[index] || AssuranceIconDefault;

export const BANK_CARD_ICONS = [BankCard1, BankCard2, BankCard3, BankCard4];

export enum BUTTON_TYPE {
  BuyNow = 1,
  AddCart = 2,
  Confirm = 3,
}

export enum ITEM_TYPE {
  Normal = 1, //普通商品
  BigItem = 20, //大件服务品
}

export const TEST_IMAGE =
  'http://imgdownload3.uk-test.jd.com/da/s960x960_jfsuktest-000-da/t1/101001602462023/2024/083109395682/111004/66d2d6dcE1b749595/90d76b397c871153.jpg!q70.webp';

// 元素曝光策略应该是全局统一的，所以不需要动态变量，直接写死一个通用的string即可
export const dataExpTagConfig =
  '{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}';

// 定义 eventName 常量，便于管理和查找
export const EVENT_NAMES = {
  MAIN_IMAGE_LOAD_ERROR: 'main_image_load_error',
  MAIN_VIDEO_PLAY_ERROR: 'main_video_play_error',
} as const;
